import {
    VIEW_VENDORLIST_REQUEST,
    VIEW_VENDORLIST_SUCCESS,
    VIEW_VENDORLIST_FAIL,
  } from "../constants/AuthConstant";


  const initialState = {
    loading: true,
    result: null,
    msg: "",
    error: "",
  };

  const VendorDashboardReducer = (state = initialState, action) => {
    switch (action.type) {
      case VIEW_VENDORLIST_REQUEST:
        return {
          ...state,
          loading: action.payload,
        };
      case VIEW_VENDORLIST_SUCCESS:
        return {
          ...state,
          result: action.result.data,
          loading: action.loading,
          msg: action.msg,
        };
      case VIEW_VENDORLIST_FAIL:
        return {
          ...state,
          error: action.error,
          loading: action.loading,
          msg: action.msg,
        };
  
      default:
        return state;
    }
  };

  export default VendorDashboardReducer;